(function() {
  'use strict';

  angular
    .module('app.mailbox')
    .factory('CustomMessageService', CustomMessageService);

  CustomMessageService.$inject = [
    '$state',
    '$rootScope',
    'APP_CONSTANTS',
    'ApiCaller',
    '$window',
    '$stateParams',
    '$q',
    '$filter'
  ];

  function CustomMessageService(
    $state,
    $rootScope,
    APP_CONSTANTS,
    ApiCaller,
    $window,
    $stateParams,
    $q,
    $filter
  ) {
    var self = this;

    self.validateEmail = validateEmail;
    self.sendCustomMessage = sendCustomMessage;

    function sendCustomMessage(messageContent) {
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.messageCollection,
        APP_CONSTANTS.rootUrl
      );

      ApiCaller.apiPost(url, messageContent).then(
        function(result) {
          deferred.resolve(result);
        },
        function(err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    function validateEmail(emails) {
      var deferred = $q.defer();
      var invalidEmails = [];

      for (var email in emails) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(emails[email])) {
          invalidEmails.push(emails[email]);
        }
      }
      if (invalidEmails.length > 0) {
        deferred.reject(invalidEmails);
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    return self;
  }
})();
